const RoleTypesIds = {
  SysAdmin: 1,
  Organization_admin: 2,
  Provider_Admin: 3,
  QA: 4,
  Bridge_defects_analyzer: 7,
  CAD_technician: 8,
  Drone_operator: 9,
  DOT_Project_manager: 10,
  QC: 11,
  '3D_technician': 12,
  General: 13,
};
// export const autorizedId = (id: number, role_type_id: number) => {
//   const autorizedIds = [
//     RoleTypesIds.SysAdmin,
//     RoleTypesIds.Organization_admin,
//     RoleTypesIds.Provider_Admin,
//   ];
//   return autorizedIds.includes(role_type_id);
// };
export default RoleTypesIds;
